import * as i0 from '@angular/core';
import { Directive, Input, Injectable, Component, ViewEncapsulation, ViewChild, forwardRef, EventEmitter, Inject, Output, HostListener, NgModule } from '@angular/core';
import * as i2 from '@angular/common';
import { DOCUMENT, CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormsModule } from '@angular/forms';
import { get } from 'lodash-es';
const _c0 = ["selectorEl"];
const _c1 = (a0, a1, a2, a3) => ({
  width: a0,
  height: a1,
  top: a2,
  left: a3
});
const _c2 = (a0, a1, a2) => ({
  selectorarrow: a0,
  selectorarrowleft: a1,
  selectorarrowright: a2
});
const _c3 = (a0, a1) => ({
  headerbtnenabled: a0,
  headerbtndisabled: a1
});
const _c4 = (a0, a1) => ({
  monthlabel: a0,
  headerlabelbtnnotedit: a1
});
const _c5 = (a0, a1) => ({
  yearlabel: a0,
  headerlabelbtnnotedit: a1
});
const _c6 = (a0, a1, a2, a3, a4) => ({
  markcurrday: a0,
  currmonth: a1,
  selectedday: a2,
  disabled: a3,
  tablesingleday: a4
});
const _c7 = (a0, a1, a2) => ({
  prevmonth: a0,
  currmonth: a1,
  nextmonth: a2
});
const _c8 = a0 => ({
  dimday: a0
});
const _c9 = a0 => ({
  "background-color": a0
});
const _c10 = (a0, a1) => ({
  selectedmonth: a0,
  disabled: a1
});
const _c11 = a0 => ({
  markcurrmonth: a0
});
const _c12 = (a0, a1) => ({
  yearchangebtnenabled: a0,
  yearchangebtndisabled: a1
});
const _c13 = (a0, a1) => ({
  selectedyear: a0,
  disabled: a1
});
const _c14 = a0 => ({
  markcurryear: a0
});
function NgxMyDatePicker_table_18_th_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 15);
    i0.ɵɵtext(1, " # ");
    i0.ɵɵelementEnd();
  }
}
function NgxMyDatePicker_table_18_th_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const d_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", d_r2, " ");
  }
}
function NgxMyDatePicker_table_18_tr_6_td_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const w_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", w_r3.weekNbr, " ");
  }
}
function NgxMyDatePicker_table_18_tr_6_td_2_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 24);
  }
  if (rf & 2) {
    const d_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(1, _c9, d_r5 == null ? null : d_r5.markedDate.color));
  }
}
function NgxMyDatePicker_table_18_tr_6_td_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 20);
    i0.ɵɵlistener("click", function NgxMyDatePicker_table_18_tr_6_td_2_Template_td_click_0_listener($event) {
      const d_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r5 = i0.ɵɵnextContext(3);
      !(d_r5 == null ? null : d_r5.disabled) && ctx_r5.onCellClicked(d_r5);
      return i0.ɵɵresetView($event.stopPropagation());
    })("keydown", function NgxMyDatePicker_table_18_tr_6_td_2_Template_td_keydown_0_listener($event) {
      const d_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r5 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r5.onCellKeyDown($event, d_r5));
    });
    i0.ɵɵtemplate(1, NgxMyDatePicker_table_18_tr_6_td_2_div_1_Template, 1, 3, "div", 21);
    i0.ɵɵelementStart(2, "div", 22)(3, "span", 23);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const d_r5 = ctx.$implicit;
    const ctx_r5 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction5(6, _c6, (d_r5 == null ? null : d_r5.currDay) && (ctx_r5.opts == null ? null : ctx_r5.opts.markCurrentDay), (d_r5 == null ? null : d_r5.cmo) === ctx_r5.currMonthId && !(d_r5 == null ? null : d_r5.disabled), ctx_r5.selectedDate.day === (d_r5 == null ? null : d_r5.dateObj.day) && ctx_r5.selectedDate.month === (d_r5 == null ? null : d_r5.dateObj.month) && ctx_r5.selectedDate.year === (d_r5 == null ? null : d_r5.dateObj.year) && (d_r5 == null ? null : d_r5.cmo) === ctx_r5.currMonthId, d_r5 == null ? null : d_r5.disabled, (!(ctx_r5.opts == null ? null : ctx_r5.opts.allowSelectionOnlyInCurrentMonth) || (d_r5 == null ? null : d_r5.cmo) === ctx_r5.currMonthId && (ctx_r5.opts == null ? null : ctx_r5.opts.allowSelectionOnlyInCurrentMonth)) && !(d_r5 == null ? null : d_r5.disabled)));
    i0.ɵɵattribute("tabindex", (d_r5 == null ? null : d_r5.disabled) ? -1 : 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", d_r5 == null ? null : d_r5.markedDate.marked);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(12, _c7, (d_r5 == null ? null : d_r5.cmo) === ctx_r5.prevMonthId, (d_r5 == null ? null : d_r5.cmo) === ctx_r5.currMonthId, (d_r5 == null ? null : d_r5.cmo) === ctx_r5.nextMonthId));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c8, (d_r5 == null ? null : d_r5.highlight) && ((d_r5 == null ? null : d_r5.cmo) === ctx_r5.prevMonthId || (d_r5 == null ? null : d_r5.cmo) === ctx_r5.nextMonthId || (d_r5 == null ? null : d_r5.disabled))));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(d_r5 == null ? null : d_r5.dateObj == null ? null : d_r5.dateObj.day);
  }
}
function NgxMyDatePicker_table_18_tr_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, NgxMyDatePicker_table_18_tr_6_td_1_Template, 2, 1, "td", 17)(2, NgxMyDatePicker_table_18_tr_6_td_2_Template, 5, 18, "td", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const w_r3 = ctx.$implicit;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r5.opts == null ? null : ctx_r5.opts.showWeekNumbers) && (ctx_r5.opts == null ? null : ctx_r5.opts.firstDayOfWeek) === "mo");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", w_r3.week);
  }
}
function NgxMyDatePicker_table_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "table", 11)(1, "thead")(2, "tr");
    i0.ɵɵtemplate(3, NgxMyDatePicker_table_18_th_3_Template, 2, 0, "th", 12)(4, NgxMyDatePicker_table_18_th_4_Template, 2, 1, "th", 13);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "tbody");
    i0.ɵɵtemplate(6, NgxMyDatePicker_table_18_tr_6_Template, 3, 2, "tr", 14);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", (ctx_r5.opts == null ? null : ctx_r5.opts.showWeekNumbers) && (ctx_r5.opts == null ? null : ctx_r5.opts.firstDayOfWeek) === "mo");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r5.weekDays);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r5.dates);
  }
}
function NgxMyDatePicker_table_19_tr_2_td_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 27);
    i0.ɵɵlistener("click", function NgxMyDatePicker_table_19_tr_2_td_1_Template_td_click_0_listener($event) {
      const m_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r5 = i0.ɵɵnextContext(3);
      !(m_r8 == null ? null : m_r8.disabled) && ctx_r5.onMonthCellClicked(m_r8);
      return i0.ɵɵresetView($event.stopPropagation());
    })("keydown", function NgxMyDatePicker_table_19_tr_2_td_1_Template_td_keydown_0_listener($event) {
      const m_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r5 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r5.onMonthCellKeyDown($event, m_r8));
    });
    i0.ɵɵelementStart(1, "div", 28);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const m_r8 = ctx.$implicit;
    const ctx_r5 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c10, m_r8 == null ? null : m_r8.selected, m_r8 == null ? null : m_r8.disabled));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c11, (m_r8 == null ? null : m_r8.currMonth) && (ctx_r5.opts == null ? null : ctx_r5.opts.markCurrentMonth)));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", m_r8 == null ? null : m_r8.name, " ");
  }
}
function NgxMyDatePicker_table_19_tr_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, NgxMyDatePicker_table_19_tr_2_td_1_Template, 3, 8, "td", 26);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const mr_r9 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", mr_r9);
  }
}
function NgxMyDatePicker_table_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "table", 25)(1, "tbody");
    i0.ɵɵtemplate(2, NgxMyDatePicker_table_19_tr_2_Template, 2, 1, "tr", 14);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r5.months);
  }
}
function NgxMyDatePicker_table_20_tr_5_td_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 34);
    i0.ɵɵlistener("click", function NgxMyDatePicker_table_20_tr_5_td_1_Template_td_click_0_listener($event) {
      const y_r12 = i0.ɵɵrestoreView(_r11).$implicit;
      const ctx_r5 = i0.ɵɵnextContext(3);
      !(y_r12 == null ? null : y_r12.disabled) && ctx_r5.onYearCellClicked(y_r12);
      return i0.ɵɵresetView($event.stopPropagation());
    })("keydown", function NgxMyDatePicker_table_20_tr_5_td_1_Template_td_keydown_0_listener($event) {
      const y_r12 = i0.ɵɵrestoreView(_r11).$implicit;
      const ctx_r5 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r5.onYearCellKeyDown($event, y_r12));
    });
    i0.ɵɵelementStart(1, "div", 35);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const y_r12 = ctx.$implicit;
    const ctx_r5 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c13, y_r12 == null ? null : y_r12.selected, y_r12 == null ? null : y_r12.disabled));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c14, (y_r12 == null ? null : y_r12.currYear) && (ctx_r5.opts == null ? null : ctx_r5.opts.markCurrentYear)));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", y_r12 == null ? null : y_r12.year, " ");
  }
}
function NgxMyDatePicker_table_20_tr_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, NgxMyDatePicker_table_20_tr_5_td_1_Template, 3, 8, "td", 33);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const yr_r13 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", yr_r13);
  }
}
function NgxMyDatePicker_table_20_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "table", 29)(1, "tbody")(2, "tr")(3, "td", 30);
    i0.ɵɵlistener("click", function NgxMyDatePicker_table_20_Template_td_click_3_listener($event) {
      i0.ɵɵrestoreView(_r10);
      return i0.ɵɵresetView($event.stopPropagation());
    });
    i0.ɵɵelementStart(4, "button", 31);
    i0.ɵɵlistener("click", function NgxMyDatePicker_table_20_Template_button_click_4_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r5 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r5.onPrevYears($event, ctx_r5.years[0][0].year));
    });
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(5, NgxMyDatePicker_table_20_tr_5_Template, 2, 1, "tr", 14);
    i0.ɵɵelementStart(6, "tr")(7, "td", 30);
    i0.ɵɵlistener("click", function NgxMyDatePicker_table_20_Template_td_click_7_listener($event) {
      i0.ɵɵrestoreView(_r10);
      return i0.ɵɵresetView($event.stopPropagation());
    });
    i0.ɵɵelementStart(8, "button", 32);
    i0.ɵɵlistener("click", function NgxMyDatePicker_table_20_Template_button_click_8_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r5 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r5.onNextYears($event, ctx_r5.years[0][0].year));
    });
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", ctx_r5.prevYearsDisabled)("ngClass", i0.ɵɵpureFunction2(5, _c12, !ctx_r5.prevYearsDisabled, ctx_r5.prevYearsDisabled));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r5.years);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", ctx_r5.nextYearsDisabled)("ngClass", i0.ɵɵpureFunction2(8, _c12, !ctx_r5.nextYearsDisabled, ctx_r5.nextYearsDisabled));
  }
}
class FocusDirective {
  constructor(el, renderer) {
    this.el = el;
    this.renderer = renderer;
  }
  // Focus to element: if value 0 = don't set focus, 1 = set only focus
  ngAfterViewInit() {
    if (this.value === '0') {
      return;
    }
    this.renderer.selectRootElement(this.el.nativeElement).focus();
  }
  static {
    this.ɵfac = function FocusDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FocusDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FocusDirective,
      selectors: [["", "ngxfocus", ""]],
      inputs: {
        value: [0, "ngxfocus", "value"]
      },
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FocusDirective, [{
    type: Directive,
    args: [{
      // tslint:disable-next-line:directive-selector
      selector: '[ngxfocus]',
      standalone: false
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i0.Renderer2
  }], {
    value: [{
      type: Input,
      args: ['ngxfocus']
    }]
  });
})();
var KeyCode;
(function (KeyCode) {
  KeyCode[KeyCode["enter"] = 13] = "enter";
  KeyCode[KeyCode["esc"] = 27] = "esc";
  KeyCode[KeyCode["space"] = 32] = "space";
  KeyCode[KeyCode["leftArrow"] = 37] = "leftArrow";
  KeyCode[KeyCode["upArrow"] = 38] = "upArrow";
  KeyCode[KeyCode["rightArrow"] = 39] = "rightArrow";
  KeyCode[KeyCode["downArrow"] = 40] = "downArrow";
  KeyCode[KeyCode["tab"] = 9] = "tab";
  KeyCode[KeyCode["shift"] = 16] = "shift";
})(KeyCode || (KeyCode = {}));
var MonthId;
(function (MonthId) {
  MonthId[MonthId["prev"] = 1] = "prev";
  MonthId[MonthId["curr"] = 2] = "curr";
  MonthId[MonthId["next"] = 3] = "next";
})(MonthId || (MonthId = {}));
const M = 'm';
const MM = 'mm';
const MMM = 'mmm';
const D = 'd';
const DD = 'dd';
const YYYY = 'yyyy';
class UtilService {
  constructor() {
    this.weekDays = ['su', 'mo', 'tu', 'we', 'th', 'fr', 'sa'];
  }
  // tslint:disable-next-line:max-line-length
  isDateValid(dateStr, dateFormat, minYear, maxYear, disableUntil, disableSince, disableWeekends, disableDates, disableDateRanges, disableWeekdays, monthLabels, enableDates) {
    const returnDate = {
      day: 0,
      month: 0,
      year: 0
    };
    const daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    const isMonthStr = dateFormat.indexOf(MMM) !== -1;
    const delimeters = dateFormat.match(/[^(dmy)]{1,}/g);
    const dateValue = this.getDateValue(dateStr, dateFormat, delimeters);
    const year = this.getNumberByValue(dateValue[0]);
    const month = isMonthStr ? this.getMonthNumberByMonthName(dateValue[1], monthLabels) : this.getNumberByValue(dateValue[1]);
    const day = this.getNumberByValue(dateValue[2]);
    if (month !== -1 && day !== -1 && year !== -1) {
      if (year < minYear || year > maxYear || month < 1 || month > 12) {
        return returnDate;
      }
      const date = {
        year: year,
        month: month,
        day: day
      };
      if (this.isDisabledDate(date, minYear, maxYear, disableUntil, disableSince, disableWeekends, disableDates, disableDateRanges, disableWeekdays, enableDates)) {
        return returnDate;
      }
      if (year % 400 === 0 || year % 100 !== 0 && year % 4 === 0) {
        daysInMonth[1] = 29;
      }
      if (day < 1 || day > daysInMonth[month - 1]) {
        return returnDate;
      }
      // Valid date
      return date;
    }
    return returnDate;
  }
  getDateValue(dateStr, dateFormat, delimeters) {
    let del = delimeters[0];
    if (delimeters[0] !== delimeters[1]) {
      del = delimeters[0] + delimeters[1];
    }
    const re = new RegExp('[' + del + ']');
    const ds = dateStr.split(re);
    const df = dateFormat.split(re);
    const da = [];
    for (let i = 0; i < df.length; i++) {
      if (df[i].indexOf(YYYY) !== -1) {
        da[0] = {
          value: ds[i],
          format: df[i]
        };
      }
      if (df[i].indexOf(M) !== -1) {
        da[1] = {
          value: ds[i],
          format: df[i]
        };
      }
      if (df[i].indexOf(D) !== -1) {
        da[2] = {
          value: ds[i],
          format: df[i]
        };
      }
    }
    return da;
  }
  getMonthNumberByMonthName(df, monthLabels) {
    if (df.value) {
      for (let key = 1; key <= 12; key++) {
        if (df.value.toLowerCase() === monthLabels[key].toLowerCase()) {
          return key;
        }
      }
    }
    return -1;
  }
  getNumberByValue(df) {
    if (!/^\d+$/.test(df.value)) {
      return -1;
    }
    let nbr = Number(df.value);
    if (df.format.length === 1 && df.value.length !== 1 && nbr < 10 || df.format.length === 1 && df.value.length !== 2 && nbr >= 10) {
      nbr = -1;
    } else if (df.format.length === 2 && df.value.length > 2) {
      nbr = -1;
    }
    return nbr;
  }
  parseDefaultMonth(monthString) {
    const month = {
      monthTxt: '',
      monthNbr: 0,
      year: 0
    };
    if (monthString !== '') {
      const monthDelimiter = (monthString.match(/[^0-9]/) || ['/'])[0];
      const split = monthString.split(monthDelimiter);
      // tslint:disable-next-line:radix
      month.monthNbr = split[0].length === 2 ? parseInt(split[0]) : parseInt(split[1]);
      // tslint:disable-next-line:radix
      month.year = split[0].length === 2 ? parseInt(split[1]) : parseInt(split[0]);
    }
    return month;
  }
  // tslint:disable-next-line:max-line-length
  isDisabledDate(date, minYear, maxYear, disableUntil, disableSince, disableWeekends, disableDates, disableDateRanges, disableWeekdays, enableDates) {
    for (const d of enableDates) {
      if ((d.year === 0 || d.year === date.year) && (d.month === 0 || d.month === date.month) && d.day === date.day) {
        return false;
      }
    }
    if (date.year < minYear && date.month === 12 || date.year > maxYear && date.month === 1) {
      return true;
    }
    const dateMs = this.getTimeInMilliseconds(date);
    if (this.isInitializedDate(disableUntil) && dateMs <= this.getTimeInMilliseconds(disableUntil)) {
      return true;
    }
    if (this.isInitializedDate(disableSince) && dateMs >= this.getTimeInMilliseconds(disableSince)) {
      return true;
    }
    if (disableWeekends) {
      const dayNbr = this.getDayNumber(date);
      if (dayNbr === 0 || dayNbr === 6) {
        return true;
      }
    }
    const dn = this.getDayNumber(date);
    if (disableWeekdays.length > 0) {
      for (const wd of disableWeekdays) {
        if (dn === this.getWeekdayIndex(wd)) {
          return true;
        }
      }
    }
    for (const d of disableDates) {
      if ((d.year === 0 || d.year === date.year) && (d.month === 0 || d.month === date.month) && d.day === date.day) {
        return true;
      }
    }
    for (const d of disableDateRanges) {
      if (this.isInitializedDate(d.begin) && this.isInitializedDate(d.end) && dateMs >= this.getTimeInMilliseconds(d.begin) && dateMs <= this.getTimeInMilliseconds(d.end)) {
        return true;
      }
    }
    return false;
  }
  isMarkedDate(date, markedDates, markWeekends) {
    for (const md of markedDates) {
      for (const d of md.dates) {
        if (d.year === date.year && d.month === date.month && d.day === date.day) {
          return {
            marked: true,
            color: md.color
          };
        }
      }
    }
    if (markWeekends && markWeekends.marked) {
      const dayNbr = this.getDayNumber(date);
      if (dayNbr === 0 || dayNbr === 6) {
        return {
          marked: true,
          color: markWeekends.color
        };
      }
    }
    return {
      marked: false,
      color: ''
    };
  }
  isHighlightedDate(date, sunHighlight, satHighlight, highlightDates) {
    const dayNbr = this.getDayNumber(date);
    if (sunHighlight && dayNbr === 0 || satHighlight && dayNbr === 6) {
      return true;
    }
    for (const d of highlightDates) {
      if (d.year === date.year && d.month === date.month && d.day === date.day) {
        return true;
      }
    }
    return false;
  }
  getWeekNumber(date) {
    const d = new Date(date.year, date.month - 1, date.day, 0, 0, 0, 0);
    d.setDate(d.getDate() + (d.getDay() === 0 ? -3 : 4 - d.getDay()));
    return Math.round((d.getTime() - new Date(d.getFullYear(), 0, 4).getTime()) / 86400000 / 7) + 1;
  }
  isMonthDisabledByDisableUntil(date, disableUntil) {
    return this.isInitializedDate(disableUntil) && this.getTimeInMilliseconds(date) <= this.getTimeInMilliseconds(disableUntil);
  }
  isMonthDisabledByDisableSince(date, disableSince) {
    return this.isInitializedDate(disableSince) && this.getTimeInMilliseconds(date) >= this.getTimeInMilliseconds(disableSince);
  }
  getDateModel(date, dateFormat, monthLabels, dateStr = '') {
    // tslint:disable-next-line:max-line-length
    return {
      date: date,
      jsdate: this.getDate(date),
      formatted: dateStr.length ? dateStr : this.formatDate(date, dateFormat, monthLabels),
      epoc: Math.round(this.getTimeInMilliseconds(date) / 1000.0)
    };
  }
  formatDate(date, dateFormat, monthLabels) {
    let formatted = dateFormat.replace(YYYY, String(date.year));
    if (dateFormat.indexOf(MMM) !== -1) {
      formatted = formatted.replace(MMM, monthLabels[date.month]);
    } else if (dateFormat.indexOf(MM) !== -1) {
      formatted = formatted.replace(MM, this.preZero(date.month));
    } else {
      formatted = formatted.replace(M, String(date.month));
    }
    if (dateFormat.indexOf(DD) !== -1) {
      formatted = formatted.replace(DD, this.preZero(date.day));
    } else {
      formatted = formatted.replace(D, String(date.day));
    }
    return formatted;
  }
  preZero(val) {
    return val < 10 ? '0' + val : String(val);
  }
  isInitializedDate(date) {
    return date.year !== 0 && date.month !== 0 && date.day !== 0;
  }
  getTimeInMilliseconds(date) {
    return this.getDate(date).getTime();
  }
  getDate(date) {
    return new Date(date.year, date.month - 1, date.day, 0, 0, 0, 0);
  }
  getDayNumber(date) {
    return new Date(date.year, date.month - 1, date.day, 0, 0, 0, 0).getDay();
  }
  getWeekdayIndex(wd) {
    return this.weekDays.indexOf(wd);
  }
  static {
    this.ɵfac = function UtilService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UtilService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: UtilService,
      factory: UtilService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UtilService, [{
    type: Injectable
  }], null, null);
})();

// tslint:disable-next-line:component-class-suffix
class NgxMyDatePicker {
  constructor(elem, renderer, cdr, utilService) {
    this.elem = elem;
    this.renderer = renderer;
    this.cdr = cdr;
    this.utilService = utilService;
    this.visibleMonth = {
      monthTxt: '',
      monthNbr: 0,
      year: 0
    };
    this.selectedMonth = {
      monthTxt: '',
      monthNbr: 0,
      year: 0
    };
    this.selectedDate = {
      year: 0,
      month: 0,
      day: 0
    };
    this.weekDays = [];
    this.dates = [];
    this.months = [];
    this.years = [];
    this.disableTodayBtn = false;
    this.dayIdx = 0;
    this.weekDayOpts = ['su', 'mo', 'tu', 'we', 'th', 'fr', 'sa'];
    this.selectMonth = false;
    this.selectYear = false;
    this.selectorPos = null;
    this.prevMonthDisabled = false;
    this.nextMonthDisabled = false;
    this.prevYearDisabled = false;
    this.nextYearDisabled = false;
    this.prevYearsDisabled = false;
    this.nextYearsDisabled = false;
    this.prevMonthId = MonthId.prev;
    this.currMonthId = MonthId.curr;
    this.nextMonthId = MonthId.next;
    this.clickListener = this.renderer.listen(elem.nativeElement, 'click', evt => {
      if ((this.opts.monthSelector || this.opts.yearSelector) && evt.target) {
        this.resetMonthYearSelect();
      }
    });
  }
  ngOnDestroy() {
    this.clickListener();
  }
  initialize(opts, defaultMonth, selectorPos, inputValue, dc, cvc, cbe) {
    this.opts = opts;
    this.selectorPos = selectorPos;
    this.weekDays.length = 0;
    this.isTodayDisabled();
    this.dayIdx = this.weekDayOpts.indexOf(this.opts.firstDayOfWeek);
    if (this.dayIdx !== -1) {
      let idx = this.dayIdx;
      for (let i = 0; i < this.weekDayOpts.length; i++) {
        this.weekDays.push(this.opts.dayLabels[this.weekDayOpts[idx]]);
        idx = this.weekDayOpts[idx] === 'sa' ? 0 : idx + 1;
      }
    }
    // tslint:disable-next-line:max-line-length
    const date = this.utilService.isDateValid(inputValue, this.opts.dateFormat, this.opts.minYear, this.opts.maxYear, this.opts.disableUntil, this.opts.disableSince, this.opts.disableWeekends, this.opts.disableDates, this.opts.disableDateRanges, this.opts.disableWeekdays, this.opts.monthLabels, this.opts.enableDates);
    if (date.day !== 0 && date.month !== 0 && date.year !== 0) {
      this.selectedDate = date;
    } else {
      if (defaultMonth !== null && defaultMonth !== undefined && defaultMonth !== '') {
        this.selectedMonth = this.utilService.parseDefaultMonth(defaultMonth);
      }
    }
    this.dateChanged = dc;
    this.calendarViewChanged = cvc;
    this.closedByEsc = cbe;
    this.setVisibleMonth();
  }
  setCalendarView(date) {
    this.selectedDate = date;
    this.setVisibleMonth();
  }
  resetMonthYearSelect() {
    this.selectMonth = false;
    this.selectYear = false;
  }
  onSelectMonthClicked(event) {
    event.stopPropagation();
    this.selectMonth = !this.selectMonth;
    this.selectYear = false;
    this.cdr.detectChanges();
    if (this.selectMonth) {
      const today = this.getToday();
      this.months.length = 0;
      for (let i = 1; i <= 12; i += 3) {
        const row = [];
        for (let j = i; j < i + 3; j++) {
          // tslint:disable-next-line:max-line-length
          const disabled = this.utilService.isMonthDisabledByDisableUntil({
            year: this.visibleMonth.year,
            month: j,
            day: this.daysInMonth(j, this.visibleMonth.year)
          }, this.opts.disableUntil) || this.utilService.isMonthDisabledByDisableSince({
            year: this.visibleMonth.year,
            month: j,
            day: 1
          }, this.opts.disableSince);
          // tslint:disable-next-line:max-line-length
          row.push({
            nbr: j,
            name: this.opts.monthLabels[j],
            currMonth: j === today.month && this.visibleMonth.year === today.year,
            selected: j === this.visibleMonth.monthNbr,
            disabled: disabled
          });
        }
        this.months.push(row);
      }
    }
  }
  onMonthCellClicked(cell) {
    const mc = cell.nbr !== this.visibleMonth.monthNbr;
    this.visibleMonth = {
      monthTxt: this.opts.monthLabels[cell.nbr],
      monthNbr: cell.nbr,
      year: this.visibleMonth.year
    };
    this.generateCalendar(cell.nbr, this.visibleMonth.year, mc);
    this.selectMonth = false;
    this.selectorEl.nativeElement.focus();
  }
  onMonthCellKeyDown(event, cell) {
    if ((event.keyCode === KeyCode.enter || event.keyCode === KeyCode.space) && !cell.disabled) {
      event.preventDefault();
      this.onMonthCellClicked(cell);
    }
  }
  onSelectYearClicked(event) {
    event.stopPropagation();
    this.selectYear = !this.selectYear;
    this.selectMonth = false;
    this.cdr.detectChanges();
    if (this.selectYear) {
      this.generateYears(this.visibleMonth.year);
    }
  }
  onYearCellClicked(cell) {
    const yc = cell.year !== this.visibleMonth.year;
    this.visibleMonth = {
      monthTxt: this.visibleMonth.monthTxt,
      monthNbr: this.visibleMonth.monthNbr,
      year: cell.year
    };
    this.generateCalendar(this.visibleMonth.monthNbr, cell.year, yc);
    this.selectYear = false;
    this.selectorEl.nativeElement.focus();
  }
  onPrevYears(event, year) {
    event.stopPropagation();
    this.generateYears(year - 25);
  }
  onNextYears(event, year) {
    event.stopPropagation();
    this.generateYears(year + 25);
  }
  generateYears(year) {
    this.years.length = 0;
    const today = this.getToday();
    for (let i = year; i <= 20 + year; i += 5) {
      const row = [];
      for (let j = i; j < i + 5; j++) {
        // tslint:disable-next-line:max-line-length
        const disabled = this.utilService.isMonthDisabledByDisableUntil({
          year: j,
          month: this.visibleMonth.monthNbr,
          day: this.daysInMonth(this.visibleMonth.monthNbr, j)
        }, this.opts.disableUntil) || this.utilService.isMonthDisabledByDisableSince({
          year: j,
          month: this.visibleMonth.monthNbr,
          day: 1
        }, this.opts.disableSince);
        const minMax = j < this.opts.minYear || j > this.opts.maxYear;
        row.push({
          year: j,
          currYear: j === today.year,
          selected: j === this.visibleMonth.year,
          disabled: disabled || minMax
        });
      }
      this.years.push(row);
    }
    // tslint:disable-next-line:max-line-length
    this.prevYearsDisabled = this.years[0][0].year <= this.opts.minYear || this.utilService.isMonthDisabledByDisableUntil({
      year: this.years[0][0].year - 1,
      month: this.visibleMonth.monthNbr,
      day: this.daysInMonth(this.visibleMonth.monthNbr, this.years[0][0].year - 1)
    }, this.opts.disableUntil);
    // tslint:disable-next-line:max-line-length
    this.nextYearsDisabled = this.years[4][4].year >= this.opts.maxYear || this.utilService.isMonthDisabledByDisableSince({
      year: this.years[4][4].year + 1,
      month: this.visibleMonth.monthNbr,
      day: 1
    }, this.opts.disableSince);
  }
  onYearCellKeyDown(event, cell) {
    if ((event.keyCode === KeyCode.enter || event.keyCode === KeyCode.space) && !cell.disabled) {
      event.preventDefault();
      this.onYearCellClicked(cell);
    }
  }
  isTodayDisabled() {
    // tslint:disable-next-line:max-line-length
    this.disableTodayBtn = this.utilService.isDisabledDate(this.getToday(), this.opts.minYear, this.opts.maxYear, this.opts.disableUntil, this.opts.disableSince, this.opts.disableWeekends, this.opts.disableDates, this.opts.disableDateRanges, this.opts.disableWeekdays, this.opts.enableDates);
  }
  setVisibleMonth() {
    // Sets visible month of calendar
    let y = 0,
      m = 0;
    if (this.selectedDate.year === 0 && this.selectedDate.month === 0 && this.selectedDate.day === 0) {
      if (this.selectedMonth.year === 0 && this.selectedMonth.monthNbr === 0) {
        const today = this.getToday();
        y = today.year;
        m = today.month;
      } else {
        y = this.selectedMonth.year;
        m = this.selectedMonth.monthNbr;
      }
    } else {
      y = this.selectedDate.year;
      m = this.selectedDate.month;
    }
    this.visibleMonth = {
      monthTxt: this.opts.monthLabels[m],
      monthNbr: m,
      year: y
    };
    // Create current month
    this.generateCalendar(m, y, true);
  }
  onPrevMonth() {
    // Previous month from calendar
    const d = this.getDate(this.visibleMonth.year, this.visibleMonth.monthNbr, 1);
    d.setMonth(d.getMonth() - 1);
    const y = d.getFullYear();
    const m = d.getMonth() + 1;
    this.visibleMonth = {
      monthTxt: this.opts.monthLabels[m],
      monthNbr: m,
      year: y
    };
    this.generateCalendar(m, y, true);
  }
  onNextMonth() {
    // Next month from calendar
    const d = this.getDate(this.visibleMonth.year, this.visibleMonth.monthNbr, 1);
    d.setMonth(d.getMonth() + 1);
    const y = d.getFullYear();
    const m = d.getMonth() + 1;
    this.visibleMonth = {
      monthTxt: this.opts.monthLabels[m],
      monthNbr: m,
      year: y
    };
    this.generateCalendar(m, y, true);
  }
  onPrevYear() {
    // Previous year from calendar
    this.visibleMonth.year--;
    this.generateCalendar(this.visibleMonth.monthNbr, this.visibleMonth.year, true);
  }
  onNextYear() {
    // Next year from calendar
    this.visibleMonth.year++;
    this.generateCalendar(this.visibleMonth.monthNbr, this.visibleMonth.year, true);
  }
  onCloseSelector(event) {
    if (event.keyCode === KeyCode.esc) {
      this.closedByEsc();
    }
  }
  onTodayClicked() {
    // Today button clicked
    const today = this.getToday();
    this.selectDate(today);
    if (!this.opts.closeSelectorOnDateSelect) {
      this.setVisibleMonth();
    }
  }
  onCellClicked(cell) {
    // Cell clicked on the calendar
    if (cell.cmo === this.prevMonthId) {
      // Previous month of day
      this.onPrevMonth();
      if (!this.opts.allowSelectionOnlyInCurrentMonth) {
        this.selectDate(cell.dateObj);
      }
    } else if (cell.cmo === this.currMonthId) {
      // Current month of day
      this.selectDate(cell.dateObj);
    } else if (cell.cmo === this.nextMonthId) {
      // Next month of day
      this.onNextMonth();
      if (!this.opts.allowSelectionOnlyInCurrentMonth) {
        this.selectDate(cell.dateObj);
      }
    }
    this.resetMonthYearSelect();
  }
  onCellKeyDown(event, cell) {
    // Cell keyboard handling
    if ((event.keyCode === KeyCode.enter || event.keyCode === KeyCode.space) && !cell.disabled) {
      event.preventDefault();
      this.onCellClicked(cell);
    }
  }
  selectDate(date) {
    // Notifies parent using callback
    this.selectedDate = date;
    this.dateChanged(this.utilService.getDateModel(date, this.opts.dateFormat, this.opts.monthLabels), this.opts.closeSelectorOnDateSelect);
  }
  monthStartIdx(y, m) {
    // Month start index
    const d = new Date();
    d.setDate(1);
    d.setMonth(m - 1);
    d.setFullYear(y);
    const idx = d.getDay() + this.sundayIdx();
    return idx >= 7 ? idx - 7 : idx;
  }
  daysInMonth(m, y) {
    // Return number of days of current month
    return new Date(y, m, 0).getDate();
  }
  daysInPrevMonth(m, y) {
    // Return number of days of the previous month
    const d = this.getDate(y, m, 1);
    d.setMonth(d.getMonth() - 1);
    return this.daysInMonth(d.getMonth() + 1, d.getFullYear());
  }
  isCurrDay(d, m, y, cmo, today) {
    // Check is a given date the today
    return d === today.day && m === today.month && y === today.year && cmo === this.currMonthId;
  }
  getToday() {
    const date = new Date();
    return {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate()
    };
  }
  getDayNumber(date) {
    // Get day number: su=0, mo=1, tu=2, we=3 ...
    const d = this.getDate(date.year, date.month, date.day);
    return d.getDay();
  }
  getWeekday(date) {
    // Get weekday: su, mo, tu, we ...
    return this.weekDayOpts[this.getDayNumber(date)];
  }
  getDate(year, month, day) {
    // Creates a date object from given year, month and day
    return new Date(year, month - 1, day, 0, 0, 0, 0);
  }
  sundayIdx() {
    // Index of Sunday day
    return this.dayIdx > 0 ? 7 - this.dayIdx : 0;
  }
  generateCalendar(m, y, notifyChange) {
    this.dates.length = 0;
    const today = this.getToday();
    const monthStart = this.monthStartIdx(y, m);
    const dInThisM = this.daysInMonth(m, y);
    const dInPrevM = this.daysInPrevMonth(m, y);
    let dayNbr = 1;
    let cmo = this.prevMonthId;
    for (let i = 1; i < 7; i++) {
      const week = [];
      if (i === 1) {
        // First week
        const pm = dInPrevM - monthStart + 1;
        // Previous month
        for (let j = pm; j <= dInPrevM; j++) {
          const date = {
            year: m === 1 ? y - 1 : y,
            month: m === 1 ? 12 : m - 1,
            day: j
          };
          week.push({
            dateObj: date,
            cmo: cmo,
            currDay: this.isCurrDay(j, m, y, cmo, today),
            // tslint:disable-next-line:max-line-length
            disabled: this.utilService.isDisabledDate(date, this.opts.minYear, this.opts.maxYear, this.opts.disableUntil, this.opts.disableSince, this.opts.disableWeekends, this.opts.disableDates, this.opts.disableDateRanges, this.opts.disableWeekdays, this.opts.enableDates),
            markedDate: this.utilService.isMarkedDate(date, this.opts.markDates, this.opts.markWeekends),
            highlight: this.utilService.isHighlightedDate(date, this.opts.sunHighlight, this.opts.satHighlight, this.opts.highlightDates)
          });
        }
        cmo = this.currMonthId;
        // Current month
        const daysLeft = 7 - week.length;
        for (let j = 0; j < daysLeft; j++) {
          const date = {
            year: y,
            month: m,
            day: dayNbr
          };
          week.push({
            dateObj: date,
            cmo: cmo,
            currDay: this.isCurrDay(dayNbr, m, y, cmo, today),
            // tslint:disable-next-line:max-line-length
            disabled: this.utilService.isDisabledDate(date, this.opts.minYear, this.opts.maxYear, this.opts.disableUntil, this.opts.disableSince, this.opts.disableWeekends, this.opts.disableDates, this.opts.disableDateRanges, this.opts.disableWeekdays, this.opts.enableDates),
            markedDate: this.utilService.isMarkedDate(date, this.opts.markDates, this.opts.markWeekends),
            highlight: this.utilService.isHighlightedDate(date, this.opts.sunHighlight, this.opts.satHighlight, this.opts.highlightDates)
          });
          dayNbr++;
        }
      } else {
        // Rest of the weeks
        for (let j = 1; j < 8; j++) {
          if (dayNbr > dInThisM) {
            // Next month
            dayNbr = 1;
            cmo = this.nextMonthId;
          }
          // tslint:disable-next-line:max-line-length
          const date = {
            year: cmo === this.nextMonthId && m === 12 ? y + 1 : y,
            month: cmo === this.currMonthId ? m : cmo === this.nextMonthId && m < 12 ? m + 1 : 1,
            day: dayNbr
          };
          week.push({
            dateObj: date,
            cmo: cmo,
            currDay: this.isCurrDay(dayNbr, m, y, cmo, today),
            // tslint:disable-next-line:max-line-length
            disabled: this.utilService.isDisabledDate(date, this.opts.minYear, this.opts.maxYear, this.opts.disableUntil, this.opts.disableSince, this.opts.disableWeekends, this.opts.disableDates, this.opts.disableDateRanges, this.opts.disableWeekdays, this.opts.enableDates),
            markedDate: this.utilService.isMarkedDate(date, this.opts.markDates, this.opts.markWeekends),
            highlight: this.utilService.isHighlightedDate(date, this.opts.sunHighlight, this.opts.satHighlight, this.opts.highlightDates)
          });
          dayNbr++;
        }
      }
      const weekNbr = this.opts.showWeekNumbers && this.opts.firstDayOfWeek === 'mo' ? this.utilService.getWeekNumber(week[0].dateObj) : 0;
      this.dates.push({
        week: week,
        weekNbr: weekNbr
      });
    }
    this.setHeaderBtnDisabledState(m, y);
    if (notifyChange) {
      // Notify parent
      // tslint:disable-next-line:max-line-length
      this.calendarViewChanged({
        year: y,
        month: m,
        first: {
          number: 1,
          weekday: this.getWeekday({
            year: y,
            month: m,
            day: 1
          })
        },
        last: {
          number: dInThisM,
          weekday: this.getWeekday({
            year: y,
            month: m,
            day: dInThisM
          })
        }
      });
    }
  }
  setHeaderBtnDisabledState(m, y) {
    let dpm = false;
    let dpy = false;
    let dnm = false;
    let dny = false;
    if (this.opts.disableHeaderButtons) {
      // tslint:disable-next-line:max-line-length
      dpm = this.utilService.isMonthDisabledByDisableUntil({
        year: m === 1 ? y - 1 : y,
        month: m === 1 ? 12 : m - 1,
        day: this.daysInMonth(m === 1 ? 12 : m - 1, m === 1 ? y - 1 : y)
      }, this.opts.disableUntil);
      dpy = this.utilService.isMonthDisabledByDisableUntil({
        year: y - 1,
        month: m,
        day: this.daysInMonth(m, y - 1)
      }, this.opts.disableUntil);
      dnm = this.utilService.isMonthDisabledByDisableSince({
        year: m === 12 ? y + 1 : y,
        month: m === 12 ? 1 : m + 1,
        day: 1
      }, this.opts.disableSince);
      dny = this.utilService.isMonthDisabledByDisableSince({
        year: y + 1,
        month: m,
        day: 1
      }, this.opts.disableSince);
    }
    this.prevMonthDisabled = m === 1 && y === this.opts.minYear || dpm;
    this.prevYearDisabled = y - 1 < this.opts.minYear || dpy;
    this.nextMonthDisabled = m === 12 && y === this.opts.maxYear || dnm;
    this.nextYearDisabled = y + 1 > this.opts.maxYear || dny;
  }
  static {
    this.ɵfac = function NgxMyDatePicker_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NgxMyDatePicker)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(UtilService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NgxMyDatePicker,
      selectors: [["ngx-my-date-picker"]],
      viewQuery: function NgxMyDatePicker_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.selectorEl = _t.first);
        }
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([UtilService])],
      decls: 21,
      vars: 39,
      consts: [["selectorEl", ""], [1, "ngxmdp"], ["tabindex", "0", 1, "selector", 3, "keyup", "ngxfocus", "ngStyle", "ngClass"], [1, "header"], [1, "headerbtncell"], ["type", "button", 1, "headerbtn", 3, "click", "disabled", "ngClass"], [1, "headermonthtxt"], ["type", "button", 1, "headerlabelbtn", 3, "click", "ngClass", "tabindex"], ["class", "caltable", 4, "ngIf"], ["class", "monthtable", 4, "ngIf"], ["class", "yeartable", 4, "ngIf"], [1, "caltable"], ["class", "weekdaytitle weekdaytitleweeknbr", 4, "ngIf"], ["class", "weekdaytitle", "scope", "col", 4, "ngFor", "ngForOf"], [4, "ngFor", "ngForOf"], [1, "weekdaytitle", "weekdaytitleweeknbr"], ["scope", "col", 1, "weekdaytitle"], ["class", "daycell daycellweeknbr", 4, "ngIf"], ["class", "daycell", 3, "ngClass", "click", "keydown", 4, "ngFor", "ngForOf"], [1, "daycell", "daycellweeknbr"], [1, "daycell", 3, "click", "keydown", "ngClass"], ["class", "markdate", 3, "ngStyle", 4, "ngIf"], [1, "datevalue", 3, "ngClass"], [3, "ngClass"], [1, "markdate", 3, "ngStyle"], [1, "monthtable"], ["class", "monthcell tablesinglemonth", "tabindex", "0", 3, "ngClass", "click", "keydown", 4, "ngFor", "ngForOf"], ["tabindex", "0", 1, "monthcell", "tablesinglemonth", 3, "click", "keydown", "ngClass"], [1, "monthvalue", 3, "ngClass"], [1, "yeartable"], ["colspan", "5", 1, "yearchangebtncell", 3, "click"], ["type", "button", 1, "yearchangebtn", "ngxmdpicon", "icon-ngxmydpup", 3, "click", "disabled", "ngClass"], ["type", "button", 1, "yearchangebtn", "ngxmdpicon", "icon-ngxmydpdown", 3, "click", "disabled", "ngClass"], ["class", "yearcell tablesingleyear", "tabindex", "0", 3, "ngClass", "click", "keydown", 4, "ngFor", "ngForOf"], ["tabindex", "0", 1, "yearcell", "tablesingleyear", 3, "click", "keydown", "ngClass"], [1, "yearvalue", 3, "ngClass"]],
      template: function NgxMyDatePicker_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 1)(1, "div", 2, 0);
          i0.ɵɵlistener("keyup", function NgxMyDatePicker_Template_div_keyup_1_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onCloseSelector($event));
          });
          i0.ɵɵelementStart(3, "table", 3)(4, "tr")(5, "td")(6, "div")(7, "div", 4)(8, "button", 5);
          i0.ɵɵlistener("click", function NgxMyDatePicker_Template_button_click_8_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onPrevMonth());
          });
          i0.ɵɵtext(9, " \u2039 ");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(10, "div", 6)(11, "button", 7);
          i0.ɵɵlistener("click", function NgxMyDatePicker_Template_button_click_11_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView((ctx.opts == null ? null : ctx.opts.monthSelector) && ctx.onSelectMonthClicked($event));
          });
          i0.ɵɵtext(12);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(13, "button", 7);
          i0.ɵɵlistener("click", function NgxMyDatePicker_Template_button_click_13_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView((ctx.opts == null ? null : ctx.opts.yearSelector) && ctx.onSelectYearClicked($event));
          });
          i0.ɵɵtext(14);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(15, "div", 4)(16, "button", 5);
          i0.ɵɵlistener("click", function NgxMyDatePicker_Template_button_click_16_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onNextMonth());
          });
          i0.ɵɵtext(17, " \u203A ");
          i0.ɵɵelementEnd()()()()()();
          i0.ɵɵtemplate(18, NgxMyDatePicker_table_18_Template, 7, 3, "table", 8)(19, NgxMyDatePicker_table_19_Template, 3, 1, "table", 9)(20, NgxMyDatePicker_table_20_Template, 9, 11, "table", 10);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngxfocus", 1)("ngStyle", i0.ɵɵpureFunction4(18, _c1, ctx.opts == null ? null : ctx.opts.selectorWidth, ctx.opts == null ? null : ctx.opts.selectorHeight, ctx.selectorPos == null ? null : ctx.selectorPos.top, ctx.selectorPos == null ? null : ctx.selectorPos.left))("ngClass", i0.ɵɵpureFunction3(23, _c2, ctx.opts == null ? null : ctx.opts.showSelectorArrow, (ctx.opts == null ? null : ctx.opts.showSelectorArrow) && !(ctx.opts == null ? null : ctx.opts.alignSelectorRight), (ctx.opts == null ? null : ctx.opts.showSelectorArrow) && (ctx.opts == null ? null : ctx.opts.alignSelectorRight)));
          i0.ɵɵadvance(7);
          i0.ɵɵproperty("disabled", ctx.prevMonthDisabled)("ngClass", i0.ɵɵpureFunction2(27, _c3, !ctx.prevMonthDisabled, ctx.prevMonthDisabled));
          i0.ɵɵattribute("aria-label", ctx.opts == null ? null : ctx.opts.ariaLabelPrevMonth);
          i0.ɵɵadvance(3);
          i0.ɵɵpropertyInterpolate("tabindex", (ctx.opts == null ? null : ctx.opts.monthSelector) ? "0" : "-1");
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(30, _c4, ctx.opts == null ? null : ctx.opts.monthSelector, !(ctx.opts == null ? null : ctx.opts.monthSelector)));
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", ctx.visibleMonth.monthTxt, " ");
          i0.ɵɵadvance();
          i0.ɵɵpropertyInterpolate("tabindex", (ctx.opts == null ? null : ctx.opts.yearSelector) ? "0" : "-1");
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(33, _c5, ctx.opts == null ? null : ctx.opts.yearSelector, !(ctx.opts == null ? null : ctx.opts.yearSelector)));
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", ctx.visibleMonth.year, " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("disabled", ctx.nextMonthDisabled)("ngClass", i0.ɵɵpureFunction2(36, _c3, !ctx.nextMonthDisabled, ctx.nextMonthDisabled));
          i0.ɵɵattribute("aria-label", ctx.opts == null ? null : ctx.opts.ariaLabelNextMonth);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", !ctx.selectMonth && !ctx.selectYear);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.selectMonth);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.selectYear);
        }
      },
      dependencies: [i2.NgClass, i2.NgForOf, i2.NgIf, i2.NgStyle, FocusDirective],
      styles: [".outline-style-primary-blue{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white{outline:1px dashed #fff;outline-offset:2px}.font-12{font-size:12px!important}.font-14{font-size:14px!important}.font-16{font-size:16px!important}.font-18{font-size:18px!important}.font-20{font-size:20px!important}.font-22{font-size:22px!important}.font-24{font-size:24px!important}.font-26{font-size:26px!important}.font-28{font-size:28px!important}.font-30{font-size:30px!important}.font-32{font-size:32px!important}.fade-me-in{animation:fadeIn .25s;-webkit-animation:fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.ngxmdp *{-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box;font-family:Arial,Helvetica,sans-serif;padding:0;margin:0}.ngxmdp .selector{position:absolute;padding:0;border-radius:4px;border:5px solid #0574f0;z-index:100000;animation:selectorfadein .06s}@keyframes selectorfadein{0%{opacity:0}to{opacity:1}}.ngxmdp .selectorarrow{background:#fafafa;padding:0}.ngxmdp .selectorarrow:after,.ngxmdp .selectorarrow:before{bottom:100%;border:solid transparent;content:\" \";height:0;width:0;position:absolute}.ngxmdp .selectorarrow:after{border-color:#fafafa00;border-bottom-color:#fafafa;border-width:10px;margin-left:-10px}.ngxmdp .selectorarrow:before{border-color:#ccc0;border-bottom-color:#ccc;border-width:11px;margin-left:-11px}.ngxmdp .selectorarrow:focus:before{border-bottom-color:#add8e6}.ngxmdp .selectorarrowleft:after,.ngxmdp .selectorarrowleft:before{left:24px}.ngxmdp .selectorarrowright:after,.ngxmdp .selectorarrowright:before{left:86%}.ngxmdp ::-ms-clear{display:none}.ngxmdp .headertodaybtnenabled,.ngxmdp .headerbtnenabled,.ngxmdp .yearchangebtnenabled{cursor:pointer}.ngxmdp .headertodaybtndisabled,.ngxmdp .headerbtndisabled,.ngxmdp .yearchangebtndisabled{cursor:not-allowed;opacity:.65}.ngxmdp .headertodaybtn{background:#fff}.ngxmdp .header{width:100%;height:30px;background-color:#0574f0;text-transform:uppercase;text-align:center}.ngxmdp .header td{vertical-align:middle;border:none;line-height:0}.ngxmdp .header td:nth-child(1){padding-left:4px}.ngxmdp .header td:nth-child(2){text-align:center}.ngxmdp .header td:nth-child(3){padding-right:4px}.ngxmdp .caltable,.ngxmdp .monthtable,.ngxmdp .yeartable{border-radius:0 0 4px 4px}.ngxmdp .caltable tbody tr:nth-child(6) td:first-child,.ngxmdp .monthtable tbody tr:nth-child(4) td:first-child,.ngxmdp .yeartable tbody tr:nth-child(7) td:first-child{border-bottom-left-radius:4px}.ngxmdp .caltable tbody tr:nth-child(6) td:last-child,.ngxmdp .monthtable tbody tr:nth-child(4) td:last-child,.ngxmdp .yeartable tbody tr:nth-child(7) td:last-child{border-bottom-right-radius:4px}.ngxmdp .caltable,.ngxmdp .monthtable,.ngxmdp .yeartable{table-layout:fixed;width:100%;height:calc(100% - 30px);background-color:#fff;font-size:14px}.ngxmdp .caltable,.ngxmdp .monthtable,.ngxmdp .yeartable,.ngxmdp .weekdaytitle,.ngxmdp .daycell,.ngxmdp .monthcell,.ngxmdp .yearcell{border-collapse:collapse;color:#000;line-height:1.1}.ngxmdp .weekdaytitle,.ngxmdp .daycell,.ngxmdp .monthcell,.ngxmdp .yearcell{padding:0;text-align:center}.ngxmdp .weekdaytitle{background-color:#0574f0;font-size:14px;font-weight:700;vertical-align:middle;max-width:36px;overflow:hidden;white-space:nowrap;color:#fff;text-transform:uppercase;padding:8px 0}.ngxmdp .weekdaytitleweeknbr{width:20px;border-right:1px solid #bbb}.ngxmdp .monthcell{background-color:#fafafa;overflow:hidden;white-space:nowrap}.ngxmdp .yearcell{background-color:#fafafa;width:20%}.ngxmdp .daycell .datevalue{vertical-align:middle;border:none;height:22px;width:22px;line-height:20px;border-radius:100%}.ngxmdp .daycell .datevalue span{vertical-align:middle}.ngxmdp .daycell{border:1px solid #f9f9f9;font-size:14px}.ngxmdp .daycellweeknbr{font-size:10px;border-right:1px solid #ccc;cursor:default;color:#000}.ngxmdp .prevmonth,.ngxmdp .nextmonth{color:#999}.ngxmdp .disabled{cursor:default!important;color:#ccc!important;background:#fbefef!important}.ngxmdp .highlight{color:#c30000}.ngxmdp .dimday{opacity:.5}.ngxmdp .currmonth{border:1px solid #f9f9f9}.ngxmdp .markdate{position:absolute;width:4px;height:4px;border-radius:4px}.ngxmdp .markcurrmonth,.ngxmdp .markcurryear{text-decoration:underline}.ngxmdp .markcurrday{background-color:#162b75;color:#fff}.ngxmdp .selectedday .datevalue{background-color:#162b75}.ngxmdp .daycell.selectedday{color:#fff}.ngxmdp .selectedday .ngxmdp .selectedmonth .monthvalue,.ngxmdp .selectedyear .yearvalue{border:none;background-color:#8ebfff;border-radius:2px}.ngxmdp .headerbtncell{background-color:#0574f0;display:inline-block;vertical-align:middle}.ngxmdp .yearchangebtncell{text-align:center;background-color:#0574f0}.ngxmdp .headerbtn,.ngxmdp .headerlabelbtn,.ngxmdp .yearchangebtn{background:#0574f0;border:none;height:22px;font-weight:700}.ngxmdp .headerbtn{font-size:16px;font-weight:700}.ngxmdp .headerlabelbtn{font-size:14px;outline:0;cursor:default;text-transform:uppercase;color:#fff}.ngxmdp .headerlabelbtnnotedit{cursor:default}.ngxmdp .headertodaybtn{border:1px solid #ccc}.ngxmdp .headerbtn,.ngxmdp .headermonthtxt,.ngxmdp .headeryeartxt,.ngxmdp .headertodaybtn,.ngxmdp .yearchangebtn{color:#fff}.ngxmdp .headerbtncell .headerbtn,.ngxmdp .headermonthtxt .headerlabelbtn.monthlabel,.ngxmdp .headermonthtxt .headerlabelbtn.yearlabel{font-weight:700}.ngxmdp .headertodaybtn{padding:0 4px;border-radius:4px;font-size:11px;height:22px;min-width:60px;max-width:84px;overflow:hidden;white-space:nowrap}.ngxmdp button::-moz-focus-inner{border:0}.ngxmdp .headermonthtxt,.ngxmdp .headeryeartxt{text-align:center;display:inline-block;font-size:14px;overflow:hidden;white-space:nowrap;font-weight:700;vertical-align:bottom;margin:0 10px}.ngxmdp .headertodaybtn:focus{background:#add8e6}.ngxmdp .headerbtn:focus,.ngxmdp .monthlabel:focus,.ngxmdp .yearlabel:focus,.ngxmdp .yearchangebtn:focus{color:#add8e6;outline:none}.ngxmdp .daycell:focus,.ngxmdp .monthcell:focus,.ngxmdp .yearcell:focus{outline:1px solid #ccc}.ngxmdp .icon-ngxmydpleft,.ngxmdp .icon-ngxmydpright,.ngxmdp .icon-ngxmydpup,.ngxmdp .icon-ngxmydpdown{color:#fff;font-size:20px;font-weight:400}.ngxmdp table{display:table;border-spacing:0}.ngxmdp table td{padding:0}.ngxmdp table,.ngxmdp th,.ngxmdp td{border:none}.ngxmdp .headertodaybtnenabled:hover{background-color:#e6e6e6}.ngxmdp .tablesinglemonth:hover,.ngxmdp .tablesingleyear:hover,.ngxmdp .tablesingleday:hover .datevalue{background-color:#ddd}.ngxmdp .monthlabel,.ngxmdp .yearlabel,.ngxmdp .daycell,.ngxmdp .monthcell,.ngxmdp .yearcell{cursor:pointer}@font-face{font-family:ngx-mydatepicker;src:url(data:application/octet-stream;base64,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) format(\"truetype\");font-weight:800;font-style:normal}.ngxmdp .ngxmdpicon{font-family:ngx-mydatepicker;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.ngxmdp .icon-ngxmydpright:before{content:\"\\e800\"}.ngxmdp .icon-ngxmydpleft:before{content:\"\\e801\"}.ngxmdp .icon-ngxmydptoday:before{content:\"\\e802\"}.ngxmdp .icon-ngxmydpup:before{content:\"\\e803\"}.ngxmdp .icon-ngxmydpdown:before{content:\"\\e804\"}.headermonthtxt .headerlabelbtn:first-of-type{margin-right:5px}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgxMyDatePicker, [{
    type: Component,
    args: [{
      selector: 'ngx-my-date-picker',
      providers: [UtilService],
      encapsulation: ViewEncapsulation.None,
      standalone: false,
      template: "<div class=\"ngxmdp\">\r\n\t<div\r\n\t\tclass=\"selector\"\r\n\t\t#selectorEl\r\n\t\t[ngxfocus]=\"1\"\r\n\t\t[ngStyle]=\"{\r\n\t\t\twidth: opts?.selectorWidth,\r\n\t\t\theight: opts?.selectorHeight,\r\n\t\t\ttop: selectorPos?.top,\r\n\t\t\tleft: selectorPos?.left\r\n\t\t}\"\r\n\t\t[ngClass]=\"{\r\n\t\t\tselectorarrow: opts?.showSelectorArrow,\r\n\t\t\tselectorarrowleft: opts?.showSelectorArrow && !opts?.alignSelectorRight,\r\n\t\t\tselectorarrowright: opts?.showSelectorArrow && opts?.alignSelectorRight\r\n\t\t}\"\r\n\t\t(keyup)=\"onCloseSelector($event)\"\r\n\t\ttabindex=\"0\"\r\n\t>\r\n\t\t<table class=\"header\">\r\n\t\t\t<tr>\r\n\t\t\t\t<td>\r\n\t\t\t\t\t<div>\r\n\t\t\t\t\t\t<div class=\"headerbtncell\">\r\n\t\t\t\t\t\t\t<button\r\n\t\t\t\t\t\t\t\ttype=\"button\"\r\n\t\t\t\t\t\t\t\t[attr.aria-label]=\"opts?.ariaLabelPrevMonth\"\r\n\t\t\t\t\t\t\t\tclass=\"headerbtn\"\r\n\t\t\t\t\t\t\t\t(click)=\"onPrevMonth()\"\r\n\t\t\t\t\t\t\t\t[disabled]=\"prevMonthDisabled\"\r\n\t\t\t\t\t\t\t\t[ngClass]=\"{\r\n\t\t\t\t\t\t\t\t\theaderbtnenabled: !prevMonthDisabled,\r\n\t\t\t\t\t\t\t\t\theaderbtndisabled: prevMonthDisabled\r\n\t\t\t\t\t\t\t\t}\"\r\n\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t\u2039\r\n\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"headermonthtxt\">\r\n\t\t\t\t\t\t\t<button\r\n\t\t\t\t\t\t\t\tclass=\"headerlabelbtn\"\r\n\t\t\t\t\t\t\t\t[ngClass]=\"{\r\n\t\t\t\t\t\t\t\t\tmonthlabel: opts?.monthSelector,\r\n\t\t\t\t\t\t\t\t\theaderlabelbtnnotedit: !opts?.monthSelector\r\n\t\t\t\t\t\t\t\t}\"\r\n\t\t\t\t\t\t\t\ttype=\"button\"\r\n\t\t\t\t\t\t\t\t(click)=\"opts?.monthSelector && onSelectMonthClicked($event)\"\r\n\t\t\t\t\t\t\t\ttabindex=\"{{ opts?.monthSelector ? '0' : '-1' }}\"\r\n\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t{{ visibleMonth.monthTxt }}\r\n\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t\t<button\r\n\t\t\t\t\t\t\t\tclass=\"headerlabelbtn\"\r\n\t\t\t\t\t\t\t\t[ngClass]=\"{\r\n\t\t\t\t\t\t\t\t\tyearlabel: opts?.yearSelector,\r\n\t\t\t\t\t\t\t\t\theaderlabelbtnnotedit: !opts?.yearSelector\r\n\t\t\t\t\t\t\t\t}\"\r\n\t\t\t\t\t\t\t\ttype=\"button\"\r\n\t\t\t\t\t\t\t\t(click)=\"opts?.yearSelector && onSelectYearClicked($event)\"\r\n\t\t\t\t\t\t\t\ttabindex=\"{{ opts?.yearSelector ? '0' : '-1' }}\"\r\n\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t{{ visibleMonth.year }}\r\n\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"headerbtncell\">\r\n\t\t\t\t\t\t\t<button\r\n\t\t\t\t\t\t\t\ttype=\"button\"\r\n\t\t\t\t\t\t\t\t[attr.aria-label]=\"opts?.ariaLabelNextMonth\"\r\n\t\t\t\t\t\t\t\tclass=\"headerbtn\"\r\n\t\t\t\t\t\t\t\t(click)=\"onNextMonth()\"\r\n\t\t\t\t\t\t\t\t[disabled]=\"nextMonthDisabled\"\r\n\t\t\t\t\t\t\t\t[ngClass]=\"{\r\n\t\t\t\t\t\t\t\t\theaderbtnenabled: !nextMonthDisabled,\r\n\t\t\t\t\t\t\t\t\theaderbtndisabled: nextMonthDisabled\r\n\t\t\t\t\t\t\t\t}\"\r\n\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t\t\u203A\r\n\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</td>\r\n\t\t\t</tr>\r\n\t\t</table>\r\n\r\n\t\t<table class=\"caltable\" *ngIf=\"!selectMonth && !selectYear\">\r\n\t\t\t<thead>\r\n\t\t\t\t<tr>\r\n\t\t\t\t\t<th\r\n\t\t\t\t\t\tclass=\"weekdaytitle weekdaytitleweeknbr\"\r\n\t\t\t\t\t\t*ngIf=\"opts?.showWeekNumbers && opts?.firstDayOfWeek === 'mo'\"\r\n\t\t\t\t\t>\r\n\t\t\t\t\t\t#\r\n\t\t\t\t\t</th>\r\n\t\t\t\t\t<th class=\"weekdaytitle\" scope=\"col\" *ngFor=\"let d of weekDays\">\r\n\t\t\t\t\t\t{{ d }}\r\n\t\t\t\t\t</th>\r\n\t\t\t\t</tr>\r\n\t\t\t</thead>\r\n\t\t\t<tbody>\r\n\t\t\t\t<tr *ngFor=\"let w of dates\">\r\n\t\t\t\t\t<td\r\n\t\t\t\t\t\tclass=\"daycell daycellweeknbr\"\r\n\t\t\t\t\t\t*ngIf=\"opts?.showWeekNumbers && opts?.firstDayOfWeek === 'mo'\"\r\n\t\t\t\t\t>\r\n\t\t\t\t\t\t{{ w.weekNbr }}\r\n\t\t\t\t\t</td>\r\n\t\t\t\t\t<td\r\n\t\t\t\t\t\tclass=\"daycell\"\r\n\t\t\t\t\t\t*ngFor=\"let d of w.week\"\r\n\t\t\t\t\t\t[ngClass]=\"{\r\n\t\t\t\t\t\t\tmarkcurrday: d?.currDay && opts?.markCurrentDay,\r\n\t\t\t\t\t\t\tcurrmonth: d?.cmo === currMonthId && !d?.disabled,\r\n\t\t\t\t\t\t\tselectedday:\r\n\t\t\t\t\t\t\t\tselectedDate.day === d?.dateObj.day &&\r\n\t\t\t\t\t\t\t\tselectedDate.month === d?.dateObj.month &&\r\n\t\t\t\t\t\t\t\tselectedDate.year === d?.dateObj.year &&\r\n\t\t\t\t\t\t\t\td?.cmo === currMonthId,\r\n\t\t\t\t\t\t\tdisabled: d?.disabled,\r\n\t\t\t\t\t\t\ttablesingleday:\r\n\t\t\t\t\t\t\t\t(!opts?.allowSelectionOnlyInCurrentMonth ||\r\n\t\t\t\t\t\t\t\t\t(d?.cmo === currMonthId &&\r\n\t\t\t\t\t\t\t\t\t\topts?.allowSelectionOnlyInCurrentMonth)) &&\r\n\t\t\t\t\t\t\t\t!d?.disabled\r\n\t\t\t\t\t\t}\"\r\n\t\t\t\t\t\t(click)=\"!d?.disabled && onCellClicked(d); $event.stopPropagation()\"\r\n\t\t\t\t\t\t(keydown)=\"onCellKeyDown($event, d)\"\r\n\t\t\t\t\t\t[attr.tabindex]=\"d?.disabled ? -1 : 0\"\r\n\t\t\t\t\t>\r\n\t\t\t\t\t\t<div\r\n\t\t\t\t\t\t\t*ngIf=\"d?.markedDate.marked\"\r\n\t\t\t\t\t\t\tclass=\"markdate\"\r\n\t\t\t\t\t\t\t[ngStyle]=\"{ 'background-color': d?.markedDate.color }\"\r\n\t\t\t\t\t\t></div>\r\n\t\t\t\t\t\t<div\r\n\t\t\t\t\t\t\tclass=\"datevalue\"\r\n\t\t\t\t\t\t\t[ngClass]=\"{\r\n\t\t\t\t\t\t\t\tprevmonth: d?.cmo === prevMonthId,\r\n\t\t\t\t\t\t\t\tcurrmonth: d?.cmo === currMonthId,\r\n\t\t\t\t\t\t\t\tnextmonth: d?.cmo === nextMonthId\r\n\t\t\t\t\t\t\t}\"\r\n\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t<span\r\n\t\t\t\t\t\t\t\t[ngClass]=\"{\r\n\t\t\t\t\t\t\t\t\tdimday:\r\n\t\t\t\t\t\t\t\t\t\td?.highlight &&\r\n\t\t\t\t\t\t\t\t\t\t(d?.cmo === prevMonthId ||\r\n\t\t\t\t\t\t\t\t\t\t\td?.cmo === nextMonthId ||\r\n\t\t\t\t\t\t\t\t\t\t\td?.disabled)\r\n\t\t\t\t\t\t\t\t}\"\r\n\t\t\t\t\t\t\t\t>{{ d?.dateObj?.day }}</span\r\n\t\t\t\t\t\t\t>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</td>\r\n\t\t\t\t</tr>\r\n\t\t\t</tbody>\r\n\t\t</table>\r\n\t\t<table class=\"monthtable\" *ngIf=\"selectMonth\">\r\n\t\t\t<tbody>\r\n\t\t\t\t<tr *ngFor=\"let mr of months\">\r\n\t\t\t\t\t<td\r\n\t\t\t\t\t\tclass=\"monthcell tablesinglemonth\"\r\n\t\t\t\t\t\t[ngClass]=\"{ selectedmonth: m?.selected, disabled: m?.disabled }\"\r\n\t\t\t\t\t\t*ngFor=\"let m of mr\"\r\n\t\t\t\t\t\t(click)=\"\r\n\t\t\t\t\t\t\t!m?.disabled && onMonthCellClicked(m); $event.stopPropagation()\r\n\t\t\t\t\t\t\"\r\n\t\t\t\t\t\t(keydown)=\"onMonthCellKeyDown($event, m)\"\r\n\t\t\t\t\t\ttabindex=\"0\"\r\n\t\t\t\t\t>\r\n\t\t\t\t\t\t<div\r\n\t\t\t\t\t\t\tclass=\"monthvalue\"\r\n\t\t\t\t\t\t\t[ngClass]=\"{\r\n\t\t\t\t\t\t\t\tmarkcurrmonth: m?.currMonth && opts?.markCurrentMonth\r\n\t\t\t\t\t\t\t}\"\r\n\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t{{ m?.name }}\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</td>\r\n\t\t\t\t</tr>\r\n\t\t\t</tbody>\r\n\t\t</table>\r\n\t\t<table class=\"yeartable\" *ngIf=\"selectYear\">\r\n\t\t\t<tbody>\r\n\t\t\t\t<tr>\r\n\t\t\t\t\t<td\r\n\t\t\t\t\t\tcolspan=\"5\"\r\n\t\t\t\t\t\tclass=\"yearchangebtncell\"\r\n\t\t\t\t\t\t(click)=\"$event.stopPropagation()\"\r\n\t\t\t\t\t>\r\n\t\t\t\t\t\t<button\r\n\t\t\t\t\t\t\ttype=\"button\"\r\n\t\t\t\t\t\t\tclass=\"yearchangebtn ngxmdpicon icon-ngxmydpup\"\r\n\t\t\t\t\t\t\t(click)=\"onPrevYears($event, years[0][0].year)\"\r\n\t\t\t\t\t\t\t[disabled]=\"prevYearsDisabled\"\r\n\t\t\t\t\t\t\t[ngClass]=\"{\r\n\t\t\t\t\t\t\t\tyearchangebtnenabled: !prevYearsDisabled,\r\n\t\t\t\t\t\t\t\tyearchangebtndisabled: prevYearsDisabled\r\n\t\t\t\t\t\t\t}\"\r\n\t\t\t\t\t\t></button>\r\n\t\t\t\t\t</td>\r\n\t\t\t\t</tr>\r\n\t\t\t\t<tr *ngFor=\"let yr of years\">\r\n\t\t\t\t\t<td\r\n\t\t\t\t\t\tclass=\"yearcell tablesingleyear\"\r\n\t\t\t\t\t\t[ngClass]=\"{ selectedyear: y?.selected, disabled: y?.disabled }\"\r\n\t\t\t\t\t\t*ngFor=\"let y of yr\"\r\n\t\t\t\t\t\t(click)=\"\r\n\t\t\t\t\t\t\t!y?.disabled && onYearCellClicked(y); $event.stopPropagation()\r\n\t\t\t\t\t\t\"\r\n\t\t\t\t\t\t(keydown)=\"onYearCellKeyDown($event, y)\"\r\n\t\t\t\t\t\ttabindex=\"0\"\r\n\t\t\t\t\t>\r\n\t\t\t\t\t\t<div\r\n\t\t\t\t\t\t\tclass=\"yearvalue\"\r\n\t\t\t\t\t\t\t[ngClass]=\"{ markcurryear: y?.currYear && opts?.markCurrentYear }\"\r\n\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t{{ y?.year }}\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</td>\r\n\t\t\t\t</tr>\r\n\t\t\t\t<tr>\r\n\t\t\t\t\t<td\r\n\t\t\t\t\t\tcolspan=\"5\"\r\n\t\t\t\t\t\tclass=\"yearchangebtncell\"\r\n\t\t\t\t\t\t(click)=\"$event.stopPropagation()\"\r\n\t\t\t\t\t>\r\n\t\t\t\t\t\t<button\r\n\t\t\t\t\t\t\ttype=\"button\"\r\n\t\t\t\t\t\t\tclass=\"yearchangebtn ngxmdpicon icon-ngxmydpdown\"\r\n\t\t\t\t\t\t\t(click)=\"onNextYears($event, years[0][0].year)\"\r\n\t\t\t\t\t\t\t[disabled]=\"nextYearsDisabled\"\r\n\t\t\t\t\t\t\t[ngClass]=\"{\r\n\t\t\t\t\t\t\t\tyearchangebtnenabled: !nextYearsDisabled,\r\n\t\t\t\t\t\t\t\tyearchangebtndisabled: nextYearsDisabled\r\n\t\t\t\t\t\t\t}\"\r\n\t\t\t\t\t\t></button>\r\n\t\t\t\t\t</td>\r\n\t\t\t\t</tr>\r\n\t\t\t</tbody>\r\n\t\t</table>\r\n\t</div>\r\n</div>\r\n",
      styles: [".outline-style-primary-blue{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white{outline:1px dashed #fff;outline-offset:2px}.font-12{font-size:12px!important}.font-14{font-size:14px!important}.font-16{font-size:16px!important}.font-18{font-size:18px!important}.font-20{font-size:20px!important}.font-22{font-size:22px!important}.font-24{font-size:24px!important}.font-26{font-size:26px!important}.font-28{font-size:28px!important}.font-30{font-size:30px!important}.font-32{font-size:32px!important}.fade-me-in{animation:fadeIn .25s;-webkit-animation:fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.ngxmdp *{-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box;font-family:Arial,Helvetica,sans-serif;padding:0;margin:0}.ngxmdp .selector{position:absolute;padding:0;border-radius:4px;border:5px solid #0574f0;z-index:100000;animation:selectorfadein .06s}@keyframes selectorfadein{0%{opacity:0}to{opacity:1}}.ngxmdp .selectorarrow{background:#fafafa;padding:0}.ngxmdp .selectorarrow:after,.ngxmdp .selectorarrow:before{bottom:100%;border:solid transparent;content:\" \";height:0;width:0;position:absolute}.ngxmdp .selectorarrow:after{border-color:#fafafa00;border-bottom-color:#fafafa;border-width:10px;margin-left:-10px}.ngxmdp .selectorarrow:before{border-color:#ccc0;border-bottom-color:#ccc;border-width:11px;margin-left:-11px}.ngxmdp .selectorarrow:focus:before{border-bottom-color:#add8e6}.ngxmdp .selectorarrowleft:after,.ngxmdp .selectorarrowleft:before{left:24px}.ngxmdp .selectorarrowright:after,.ngxmdp .selectorarrowright:before{left:86%}.ngxmdp ::-ms-clear{display:none}.ngxmdp .headertodaybtnenabled,.ngxmdp .headerbtnenabled,.ngxmdp .yearchangebtnenabled{cursor:pointer}.ngxmdp .headertodaybtndisabled,.ngxmdp .headerbtndisabled,.ngxmdp .yearchangebtndisabled{cursor:not-allowed;opacity:.65}.ngxmdp .headertodaybtn{background:#fff}.ngxmdp .header{width:100%;height:30px;background-color:#0574f0;text-transform:uppercase;text-align:center}.ngxmdp .header td{vertical-align:middle;border:none;line-height:0}.ngxmdp .header td:nth-child(1){padding-left:4px}.ngxmdp .header td:nth-child(2){text-align:center}.ngxmdp .header td:nth-child(3){padding-right:4px}.ngxmdp .caltable,.ngxmdp .monthtable,.ngxmdp .yeartable{border-radius:0 0 4px 4px}.ngxmdp .caltable tbody tr:nth-child(6) td:first-child,.ngxmdp .monthtable tbody tr:nth-child(4) td:first-child,.ngxmdp .yeartable tbody tr:nth-child(7) td:first-child{border-bottom-left-radius:4px}.ngxmdp .caltable tbody tr:nth-child(6) td:last-child,.ngxmdp .monthtable tbody tr:nth-child(4) td:last-child,.ngxmdp .yeartable tbody tr:nth-child(7) td:last-child{border-bottom-right-radius:4px}.ngxmdp .caltable,.ngxmdp .monthtable,.ngxmdp .yeartable{table-layout:fixed;width:100%;height:calc(100% - 30px);background-color:#fff;font-size:14px}.ngxmdp .caltable,.ngxmdp .monthtable,.ngxmdp .yeartable,.ngxmdp .weekdaytitle,.ngxmdp .daycell,.ngxmdp .monthcell,.ngxmdp .yearcell{border-collapse:collapse;color:#000;line-height:1.1}.ngxmdp .weekdaytitle,.ngxmdp .daycell,.ngxmdp .monthcell,.ngxmdp .yearcell{padding:0;text-align:center}.ngxmdp .weekdaytitle{background-color:#0574f0;font-size:14px;font-weight:700;vertical-align:middle;max-width:36px;overflow:hidden;white-space:nowrap;color:#fff;text-transform:uppercase;padding:8px 0}.ngxmdp .weekdaytitleweeknbr{width:20px;border-right:1px solid #bbb}.ngxmdp .monthcell{background-color:#fafafa;overflow:hidden;white-space:nowrap}.ngxmdp .yearcell{background-color:#fafafa;width:20%}.ngxmdp .daycell .datevalue{vertical-align:middle;border:none;height:22px;width:22px;line-height:20px;border-radius:100%}.ngxmdp .daycell .datevalue span{vertical-align:middle}.ngxmdp .daycell{border:1px solid #f9f9f9;font-size:14px}.ngxmdp .daycellweeknbr{font-size:10px;border-right:1px solid #ccc;cursor:default;color:#000}.ngxmdp .prevmonth,.ngxmdp .nextmonth{color:#999}.ngxmdp .disabled{cursor:default!important;color:#ccc!important;background:#fbefef!important}.ngxmdp .highlight{color:#c30000}.ngxmdp .dimday{opacity:.5}.ngxmdp .currmonth{border:1px solid #f9f9f9}.ngxmdp .markdate{position:absolute;width:4px;height:4px;border-radius:4px}.ngxmdp .markcurrmonth,.ngxmdp .markcurryear{text-decoration:underline}.ngxmdp .markcurrday{background-color:#162b75;color:#fff}.ngxmdp .selectedday .datevalue{background-color:#162b75}.ngxmdp .daycell.selectedday{color:#fff}.ngxmdp .selectedday .ngxmdp .selectedmonth .monthvalue,.ngxmdp .selectedyear .yearvalue{border:none;background-color:#8ebfff;border-radius:2px}.ngxmdp .headerbtncell{background-color:#0574f0;display:inline-block;vertical-align:middle}.ngxmdp .yearchangebtncell{text-align:center;background-color:#0574f0}.ngxmdp .headerbtn,.ngxmdp .headerlabelbtn,.ngxmdp .yearchangebtn{background:#0574f0;border:none;height:22px;font-weight:700}.ngxmdp .headerbtn{font-size:16px;font-weight:700}.ngxmdp .headerlabelbtn{font-size:14px;outline:0;cursor:default;text-transform:uppercase;color:#fff}.ngxmdp .headerlabelbtnnotedit{cursor:default}.ngxmdp .headertodaybtn{border:1px solid #ccc}.ngxmdp .headerbtn,.ngxmdp .headermonthtxt,.ngxmdp .headeryeartxt,.ngxmdp .headertodaybtn,.ngxmdp .yearchangebtn{color:#fff}.ngxmdp .headerbtncell .headerbtn,.ngxmdp .headermonthtxt .headerlabelbtn.monthlabel,.ngxmdp .headermonthtxt .headerlabelbtn.yearlabel{font-weight:700}.ngxmdp .headertodaybtn{padding:0 4px;border-radius:4px;font-size:11px;height:22px;min-width:60px;max-width:84px;overflow:hidden;white-space:nowrap}.ngxmdp button::-moz-focus-inner{border:0}.ngxmdp .headermonthtxt,.ngxmdp .headeryeartxt{text-align:center;display:inline-block;font-size:14px;overflow:hidden;white-space:nowrap;font-weight:700;vertical-align:bottom;margin:0 10px}.ngxmdp .headertodaybtn:focus{background:#add8e6}.ngxmdp .headerbtn:focus,.ngxmdp .monthlabel:focus,.ngxmdp .yearlabel:focus,.ngxmdp .yearchangebtn:focus{color:#add8e6;outline:none}.ngxmdp .daycell:focus,.ngxmdp .monthcell:focus,.ngxmdp .yearcell:focus{outline:1px solid #ccc}.ngxmdp .icon-ngxmydpleft,.ngxmdp .icon-ngxmydpright,.ngxmdp .icon-ngxmydpup,.ngxmdp .icon-ngxmydpdown{color:#fff;font-size:20px;font-weight:400}.ngxmdp table{display:table;border-spacing:0}.ngxmdp table td{padding:0}.ngxmdp table,.ngxmdp th,.ngxmdp td{border:none}.ngxmdp .headertodaybtnenabled:hover{background-color:#e6e6e6}.ngxmdp .tablesinglemonth:hover,.ngxmdp .tablesingleyear:hover,.ngxmdp .tablesingleday:hover .datevalue{background-color:#ddd}.ngxmdp .monthlabel,.ngxmdp .yearlabel,.ngxmdp .daycell,.ngxmdp .monthcell,.ngxmdp .yearcell{cursor:pointer}@font-face{font-family:ngx-mydatepicker;src:url(data:application/octet-stream;base64,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) format(\"truetype\");font-weight:800;font-style:normal}.ngxmdp .ngxmdpicon{font-family:ngx-mydatepicker;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.ngxmdp .icon-ngxmydpright:before{content:\"\\e800\"}.ngxmdp .icon-ngxmydpleft:before{content:\"\\e801\"}.ngxmdp .icon-ngxmydptoday:before{content:\"\\e802\"}.ngxmdp .icon-ngxmydpup:before{content:\"\\e803\"}.ngxmdp .icon-ngxmydpdown:before{content:\"\\e804\"}.headermonthtxt .headerlabelbtn:first-of-type{margin-right:5px}\n"]
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i0.Renderer2
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: UtilService
  }], {
    selectorEl: [{
      type: ViewChild,
      args: ['selectorEl', {
        static: true
      }]
    }]
  });
})();
var CalToggle;
(function (CalToggle) {
  CalToggle[CalToggle["Open"] = 1] = "Open";
  CalToggle[CalToggle["CloseByDateSel"] = 2] = "CloseByDateSel";
  CalToggle[CalToggle["CloseByCalBtn"] = 3] = "CloseByCalBtn";
  CalToggle[CalToggle["CloseByOutClick"] = 4] = "CloseByOutClick";
  CalToggle[CalToggle["CloseByEsc"] = 5] = "CloseByEsc";
})(CalToggle || (CalToggle = {}));
var Year;
(function (Year) {
  Year[Year["min"] = 1000] = "min";
  Year[Year["max"] = 9999] = "max";
})(Year || (Year = {}));

/**
 * Configuration service for the NgxMyDatePicker component.
 * You can inject this service, typically in your root component, and customize the values of its properties in
 * order to provide default values for all the datepickers used in the application.
 */
class NgxMyDatePickerConfig {
  constructor() {
    this.dayLabels = {
      su: 'Sun',
      mo: 'Mon',
      tu: 'Tue',
      we: 'Wed',
      th: 'Thu',
      fr: 'Fri',
      sa: 'Sat'
    };
    this.monthLabels = {
      1: 'Jan',
      2: 'Feb',
      3: 'Mar',
      4: 'Apr',
      5: 'May',
      6: 'Jun',
      7: 'Jul',
      8: 'Aug',
      9: 'Sep',
      10: 'Oct',
      11: 'Nov',
      12: 'Dec'
    };
    this.dateFormat = 'yyyy-mm-dd';
    this.showTodayBtn = true;
    this.todayBtnTxt = 'Today';
    this.firstDayOfWeek = 'mo';
    this.satHighlight = false;
    this.sunHighlight = true;
    this.highlightDates = [];
    this.markCurrentDay = true;
    this.markCurrentMonth = true;
    this.markCurrentYear = true;
    this.monthSelector = true;
    this.yearSelector = true;
    this.disableHeaderButtons = true;
    this.showWeekNumbers = false;
    this.selectorHeight = '232px';
    this.selectorWidth = '252px';
    this.disableUntil = {
      year: 0,
      month: 0,
      day: 0
    };
    this.disableSince = {
      year: 0,
      month: 0,
      day: 0
    };
    this.disableDates = [];
    this.enableDates = [];
    this.markDates = [];
    this.markWeekends = {};
    this.disableDateRanges = [];
    this.disableWeekends = false;
    this.disableWeekdays = [];
    this.alignSelectorRight = false;
    this.openSelectorTopOfInput = false;
    this.closeSelectorOnDateSelect = true;
    this.closeSelectorOnDocumentClick = true;
    this.minYear = Year.min;
    this.maxYear = Year.max;
    this.showSelectorArrow = true;
    this.allowSelectionOnlyInCurrentMonth = true;
    this.appendSelectorToBody = false;
    this.focusInputOnDateSelect = true;
    this.ariaLabelPrevMonth = 'Previous Month';
    this.ariaLabelNextMonth = 'Next Month';
    this.ariaLabelPrevYear = 'Previous Year';
    this.ariaLabelNextYear = 'Next Year';
  }
  static {
    this.ɵfac = function NgxMyDatePickerConfig_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NgxMyDatePickerConfig)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: NgxMyDatePickerConfig,
      factory: NgxMyDatePickerConfig.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgxMyDatePickerConfig, [{
    type: Injectable
  }], null, null);
})();
const NGX_DP_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => NgxMyDatePickerDirective),
  multi: true
};
const NGX_DP_VALIDATORS = {
  provide: NG_VALIDATORS,
  useExisting: forwardRef(() => NgxMyDatePickerDirective),
  multi: true
};
class NgxMyDatePickerDirective {
  constructor(utilService, vcRef, cfr, renderer, cdr, elem, config, document) {
    this.utilService = utilService;
    this.vcRef = vcRef;
    this.cfr = cfr;
    this.renderer = renderer;
    this.cdr = cdr;
    this.elem = elem;
    this.config = config;
    this.document = document;
    this.dateChanged = new EventEmitter();
    this.inputFieldChanged = new EventEmitter();
    this.calendarViewChanged = new EventEmitter();
    this.calendarToggle = new EventEmitter();
    this.cRef = null;
    this.inputText = '';
    this.preventClose = false;
    this.disabled = false;
    this.onChangeCb = () => {};
    this.onTouchedCb = () => {};
    // wrapper with arrow function to preserve the use of 'this' word
    this.onClickWrapper = ev => {
      this.onClick(ev);
    };
    this.opts = Object.assign({}, this.config);
    this.parseOptions(this.config);
  }
  onKeyUp(evt) {
    if (this.ignoreKeyPress(evt.keyCode)) {
      return;
    } else if (evt.keyCode === KeyCode.esc) {
      this.closeSelector(CalToggle.CloseByEsc);
    } else {
      // tslint:disable-next-line:max-line-length
      const date = this.utilService.isDateValid(this.elem.nativeElement.value, this.opts.dateFormat, this.opts.minYear, this.opts.maxYear, this.opts.disableUntil, this.opts.disableSince, this.opts.disableWeekends, this.opts.disableDates, this.opts.disableDateRanges, this.opts.disableWeekdays, this.opts.monthLabels, this.opts.enableDates);
      if (this.utilService.isInitializedDate(date)) {
        const dateModel = this.utilService.getDateModel(date, this.opts.dateFormat, this.opts.monthLabels, this.elem.nativeElement.value);
        this.emitDateChanged(dateModel);
        this.updateModel(dateModel);
        this.emitInputFieldChanged(dateModel.formatted, true);
        if (this.opts.closeSelectorOnDateSelect) {
          this.closeSelector(CalToggle.CloseByDateSel);
        } else if (this.cRef !== null) {
          this.cRef.instance.setCalendarView(date);
        }
      } else {
        if (this.inputText !== this.elem.nativeElement.value) {
          if (this.elem.nativeElement.value === '') {
            this.clearDate();
          } else {
            this.onChangeCb(null);
            this.emitInputFieldChanged(this.elem.nativeElement.value, false);
          }
        }
      }
      this.inputText = this.elem.nativeElement.value;
    }
  }
  onBlur() {
    this.onTouchedCb();
  }
  onClick(evt) {
    // tslint:disable-next-line:max-line-length
    if (this.opts.closeSelectorOnDocumentClick && !this.preventClose && evt.target && this.cRef !== null && this.elem.nativeElement !== evt.target && !this.cRef.location.nativeElement.contains(evt.target) && !this.disabled) {
      this.closeSelector(CalToggle.CloseByOutClick);
    }
  }
  ngOnChanges(changes) {
    if (changes.hasOwnProperty('options')) {
      this.parseOptions(changes['options'].currentValue);
    }
    if (changes.hasOwnProperty('defaultMonth')) {
      let dm = changes['defaultMonth'].currentValue;
      if (typeof dm === 'object') {
        dm = dm.defMonth;
      }
      this.defaultMonth = dm;
    }
  }
  ngOnDestroy() {
    this.closeCalendar();
  }
  parseOptions(opts) {
    if (opts !== undefined) {
      Object.keys(opts).forEach(k => {
        this.opts[k] = opts[k];
      });
    }
    if (get(this.opts, 'minYear') < Year.min) {
      this.opts.minYear = Year.min;
    }
    if (get(this.opts, 'maxYear') > Year.max) {
      this.opts.maxYear = Year.max;
    }
  }
  writeValue(value) {
    if (!this.disabled) {
      if (value && (value['date'] || value['jsdate'])) {
        const formatted = this.utilService.formatDate(value['date'] ? value['date'] : this.jsDateToMyDate(value['jsdate']), this.opts.dateFormat, this.opts.monthLabels);
        // tslint:disable-next-line:max-line-length
        const date = this.utilService.isDateValid(formatted, this.opts.dateFormat, this.opts.minYear, this.opts.maxYear, this.opts.disableUntil, this.opts.disableSince, this.opts.disableWeekends, this.opts.disableDates, this.opts.disableDateRanges, this.opts.disableWeekdays, this.opts.monthLabels, this.opts.enableDates);
        this.setInputValue(formatted);
        this.emitInputFieldChanged(formatted, this.utilService.isInitializedDate(date));
      } else if (value === null || value === '') {
        this.setInputValue('');
        this.emitInputFieldChanged('', false);
      }
    }
  }
  registerOnChange(fn) {
    this.onChangeCb = fn;
  }
  registerOnTouched(fn) {
    this.onTouchedCb = fn;
  }
  setDisabledState(isDisabled) {
    this.disabled = isDisabled;
    this.renderer.setProperty(this.elem.nativeElement, 'disabled', isDisabled);
    if (isDisabled) {
      this.closeCalendar();
    }
  }
  validate(_c) {
    if (this.elem.nativeElement.value === null || this.elem.nativeElement.value === '') {
      return null;
    }
    // tslint:disable-next-line:max-line-length
    const date = this.utilService.isDateValid(this.elem.nativeElement.value, this.opts.dateFormat, this.opts.minYear, this.opts.maxYear, this.opts.disableUntil, this.opts.disableSince, this.opts.disableWeekends, this.opts.disableDates, this.opts.disableDateRanges, this.opts.disableWeekdays, this.opts.monthLabels, this.opts.enableDates);
    if (!this.utilService.isInitializedDate(date)) {
      return {
        invalidDateFormat: true
      };
    }
    return null;
  }
  openCalendar() {
    if (this.disabled) {
      return;
    }
    this.preventClose = true;
    this.cdr.detectChanges();
    if (this.cRef === null) {
      this.cRef = this.vcRef.createComponent(this.cfr.resolveComponentFactory(NgxMyDatePicker));
      this.appendSelector(this.cRef.location.nativeElement);
      this.cRef.instance.initialize(this.opts, this.defaultMonth, this.getSelectorPosition(this.elem.nativeElement), this.elem.nativeElement.value, (dm, close) => {
        this.focusToInput();
        this.emitDateChanged(dm);
        this.emitInputFieldChanged(dm.formatted, true);
        this.updateModel(dm);
        if (close) {
          this.closeSelector(CalToggle.CloseByDateSel);
        }
      }, cvc => {
        this.emitCalendarChanged(cvc);
      }, () => {
        this.closeSelector(CalToggle.CloseByEsc);
      });
      this.emitCalendarToggle(CalToggle.Open);
    }
    setTimeout(() => {
      this.preventClose = false;
    }, 50);
  }
  closeCalendar() {
    this.closeSelector(CalToggle.CloseByCalBtn);
  }
  toggleCalendar() {
    if (this.disabled) {
      return;
    }
    if (this.cRef === null) {
      document.addEventListener('click', this.onClickWrapper);
      this.openCalendar();
    } else {
      document.removeEventListener('click', this.onClickWrapper);
      this.closeSelector(CalToggle.CloseByCalBtn);
    }
  }
  clearDate() {
    if (this.disabled) {
      return;
    }
    this.setInputValue('');
    this.emitInputFieldChanged('', false);
    this.emitDateChanged({
      date: {
        year: 0,
        month: 0,
        day: 0
      },
      jsdate: null,
      formatted: '',
      epoc: 0
    });
    this.onChangeCb(null);
    this.onTouchedCb();
    this.closeSelector(CalToggle.CloseByCalBtn);
  }
  isDateValid() {
    if (this.elem.nativeElement.value !== '') {
      // tslint:disable-next-line:max-line-length
      const date = this.utilService.isDateValid(this.elem.nativeElement.value, this.opts.dateFormat, this.opts.minYear, this.opts.maxYear, this.opts.disableUntil, this.opts.disableSince, this.opts.disableWeekends, this.opts.disableDates, this.opts.disableDateRanges, this.opts.disableWeekdays, this.opts.monthLabels, this.opts.enableDates);
      if (this.utilService.isInitializedDate(date)) {
        this.emitInputFieldChanged(this.elem.nativeElement.value, true);
        return true;
      }
    }
    this.emitInputFieldChanged(this.elem.nativeElement.value, false);
    return false;
  }
  ignoreKeyPress(keyCode) {
    // tslint:disable-next-line:max-line-length
    return keyCode === KeyCode.leftArrow || keyCode === KeyCode.rightArrow || keyCode === KeyCode.upArrow || keyCode === KeyCode.downArrow || keyCode === KeyCode.tab || keyCode === KeyCode.shift;
  }
  closeSelector(reason) {
    if (this.cRef !== null) {
      this.vcRef.remove(this.vcRef.indexOf(this.cRef.hostView));
      this.cRef = null;
      this.emitCalendarToggle(reason);
    }
  }
  updateModel(model) {
    this.setInputValue(model.formatted);
    this.onChangeCb(model);
    this.onTouchedCb();
  }
  setInputValue(value) {
    this.inputText = value;
    this.renderer.setProperty(this.elem.nativeElement, 'value', value);
  }
  focusToInput() {
    if (this.opts.focusInputOnDateSelect) {
      setTimeout(() => {
        this.elem.nativeElement.focus();
      });
    }
  }
  emitDateChanged(dateModel) {
    this.dateChanged.emit(dateModel);
  }
  emitInputFieldChanged(value, valid) {
    this.inputFieldChanged.emit({
      value: value,
      dateFormat: this.opts.dateFormat,
      valid: valid
    });
  }
  emitCalendarChanged(cvc) {
    this.calendarViewChanged.emit(cvc);
  }
  emitCalendarToggle(reason) {
    this.calendarToggle.emit(reason);
  }
  jsDateToMyDate(date) {
    return {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate()
    };
  }
  appendSelector(elem) {
    if (this.opts.appendSelectorToBody) {
      this.document.querySelector('body').appendChild(elem);
    }
  }
  getSelectorPosition(elem) {
    let top = 0;
    let left = 0;
    if (this.opts.appendSelectorToBody) {
      const b = document.body.getBoundingClientRect();
      const e = elem.getBoundingClientRect();
      top = e.top - b.top;
      left = e.left - b.left;
    }
    if (this.opts.openSelectorTopOfInput) {
      top = top - this.getSelectorDimension(this.opts.selectorHeight) - 2;
    } else {
      top = top + elem.offsetHeight + (this.opts.showSelectorArrow ? 12 : 2);
    }
    if (this.opts.alignSelectorRight) {
      left = left + elem.offsetWidth - this.getSelectorDimension(this.opts.selectorWidth);
    }
    return {
      top: 69 + 'px',
      left: left + 'px'
    };
  }
  getSelectorDimension(value) {
    return Number(value.replace('px', ''));
  }
  static {
    this.ɵfac = function NgxMyDatePickerDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NgxMyDatePickerDirective)(i0.ɵɵdirectiveInject(UtilService), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.ComponentFactoryResolver), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(NgxMyDatePickerConfig), i0.ɵɵdirectiveInject(DOCUMENT));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NgxMyDatePickerDirective,
      selectors: [["", "ngx-mydatepicker", ""]],
      hostBindings: function NgxMyDatePickerDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keyup", function NgxMyDatePickerDirective_keyup_HostBindingHandler($event) {
            return ctx.onKeyUp($event);
          })("blur", function NgxMyDatePickerDirective_blur_HostBindingHandler() {
            return ctx.onBlur();
          });
        }
      },
      inputs: {
        options: "options",
        defaultMonth: "defaultMonth"
      },
      outputs: {
        dateChanged: "dateChanged",
        inputFieldChanged: "inputFieldChanged",
        calendarViewChanged: "calendarViewChanged",
        calendarToggle: "calendarToggle"
      },
      exportAs: ["ngx-mydatepicker"],
      standalone: false,
      features: [i0.ɵɵProvidersFeature([UtilService, NGX_DP_VALUE_ACCESSOR, NGX_DP_VALIDATORS]), i0.ɵɵNgOnChangesFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgxMyDatePickerDirective, [{
    type: Directive,
    args: [{
      // tslint:disable-next-line:directive-selector
      selector: '[ngx-mydatepicker]',
      exportAs: 'ngx-mydatepicker',
      providers: [UtilService, NGX_DP_VALUE_ACCESSOR, NGX_DP_VALIDATORS],
      standalone: false
    }]
  }], () => [{
    type: UtilService
  }, {
    type: i0.ViewContainerRef
  }, {
    type: i0.ComponentFactoryResolver
  }, {
    type: i0.Renderer2
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: i0.ElementRef
  }, {
    type: NgxMyDatePickerConfig
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }], {
    options: [{
      type: Input
    }],
    defaultMonth: [{
      type: Input
    }],
    dateChanged: [{
      type: Output
    }],
    inputFieldChanged: [{
      type: Output
    }],
    calendarViewChanged: [{
      type: Output
    }],
    calendarToggle: [{
      type: Output
    }],
    onKeyUp: [{
      type: HostListener,
      args: ['keyup', ['$event']]
    }],
    onBlur: [{
      type: HostListener,
      args: ['blur']
    }]
  });
})();
class NgxMyDatePickerModule {
  static forRoot() {
    return {
      ngModule: NgxMyDatePickerModule,
      providers: [NgxMyDatePickerConfig]
    };
  }
  static {
    this.ɵfac = function NgxMyDatePickerModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NgxMyDatePickerModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: NgxMyDatePickerModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, FormsModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgxMyDatePickerModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, FormsModule],
      declarations: [NgxMyDatePicker, NgxMyDatePickerDirective, FocusDirective],
      exports: [NgxMyDatePicker, NgxMyDatePickerDirective, FocusDirective]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { FocusDirective, NgxMyDatePicker, NgxMyDatePickerConfig, NgxMyDatePickerDirective, NgxMyDatePickerModule, UtilService };
